import { Component, OnInit, Input } from '@angular/core';
import { Zmaterialdetails } from '@app/components/machine-infos/zmaterialdetails';
import { MachineInfosService } from '@app/components/machine-infos/machine-infos.service';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-fitments',
    templateUrl: './fitments.component.html',
    styleUrls: ['./fitments.component.css'],
    imports: [TranslateModule]
})
export class FitmentsComponent implements OnInit {

    @Input() optional: Zmaterialdetails[];
    @Input() fitted: Zmaterialdetails[];

    constructor(
        private readonly machineinfos: MachineInfosService) { }

    ngOnInit() {
        if (!this.optional) {
            this.machineinfos.fitmentsOptional$.subscribe(result => this.optional = result);
        }

        if (!this.fitted) {
            this.machineinfos.fitmentsFitted$.subscribe(result => this.fitted = result);
        }
    }
}
